// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"5fe448f8","83":"017b50ff","93":"d40cf54a","102":"3d23ef92","146":"565ff67a","161":"ce9baf5d","184":"d4adf057","237":"2323b48b","320":"36bbfcbe","453":"8701dc61","527":"7e98315d","530":"484de71b","650":"a530edb2","840":"f7f00dcb","943":"e70940aa","981":"ab62fa24"}[chunkId] + ".chunk.js";
};